import script from "./DialogMergeHotpepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogMergeHotpepper.vue?vue&type=script&setup=true&lang=ts"

import "./DialogMergeHotpepper.vue?vue&type=style&index=0&id=434ecba8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434ecba8"]])

export default __exports__